import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  OnDestroy
} from '@angular/core';

@Directive({
  selector: '[customTooltip]',
  standalone: true
})
export class CustomTooltipDirective implements OnDestroy {

  @Input('customTooltip') tooltipText: string | null = null;
  @Input() tooltipPosition: 'top' | 'bottom' | 'bottom-start' | 'top-start' = 'top';
  @Input() tooltipTrigger: 'hover' | 'longpress' = 'hover';
  @Input() tooltipMaxWidth?: string | null = null;

  private tooltipEl!: HTMLElement;
  private pressTimer: any;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  // ✅ SHOW TOOLTIP
  private showTooltip() {
    if (this.tooltipEl) return;
    if (!this.tooltipText || !this.tooltipText?.trim()) return;

    this.tooltipEl = this.renderer.createElement('div');
    this.tooltipEl.innerText = this.tooltipText;

    this.renderer.appendChild(document.body, this.tooltipEl);
    this.renderer.addClass(this.tooltipEl, 'custom-tooltip');
    this.renderer.addClass(this.tooltipEl, this.tooltipPosition);

    // If consumer provided a max width, enable wrapping and apply the width
    if (this.tooltipMaxWidth) {
      this.renderer.setStyle(this.tooltipEl, 'max-width', this.tooltipMaxWidth);
      this.renderer.setStyle(this.tooltipEl, 'white-space', 'normal');
      this.renderer.setStyle(this.tooltipEl, 'height', 'auto');
      this.renderer.setStyle(this.tooltipEl, 'word-break', 'break-all');
      this.renderer.setStyle(this.tooltipEl, 'padding', '8px 10px');
    }

    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const tooltipPos = this.tooltipEl.getBoundingClientRect();

    let top = 0;
    let left = 0;

    if (this.tooltipPosition === 'top') {
      top = hostPos.top - tooltipPos.height - 8;
      left = hostPos.left + (hostPos.width / 2) - (tooltipPos.width / 2);

    } else if (this.tooltipPosition === 'bottom') {
      top = hostPos.bottom + 8;
      left = hostPos.left + (hostPos.width / 2) - (tooltipPos.width / 2);

    } else if (this.tooltipPosition === 'bottom-start') {
      top = hostPos.bottom + 8;
      left = hostPos.left; // ✅ starts from hovered element's left edge
    } else if (this.tooltipPosition === 'top-start') {
      top = hostPos.top - tooltipPos.height - 20;
      left = hostPos.left; // ✅ starts from hovered element's left edge
    }

    this.renderer.setStyle(this.tooltipEl, 'top', `${top}px`);
    this.renderer.setStyle(this.tooltipEl, 'left', `${left}px`);
  }

  // ✅ HIDE TOOLTIP
  private hideTooltip() {
    if (this.tooltipEl) {
      this.renderer.removeChild(document.body, this.tooltipEl);
      this.tooltipEl = null as any;
    }
  }

  // ✅ HOVER SUPPORT
  @HostListener('mouseenter')
  onMouseEnter() {
    if (this.tooltipTrigger === 'hover') {
      this.showTooltip();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.tooltipTrigger === 'hover') {
      this.hideTooltip();
    }
  }

  // ✅ LONG PRESS SUPPORT (MOBILE)
  @HostListener('touchstart')
  onTouchStart() {
    if (this.tooltipTrigger === 'longpress') {
      this.pressTimer = setTimeout(() => {
        this.showTooltip();
      }, 500);
    }
  }

  @HostListener('touchend')
  onTouchEnd() {
    clearTimeout(this.pressTimer);
    this.hideTooltip();
  }

  ngOnDestroy() {
    this.hideTooltip();
  }
}

